import { render, staticRenderFns } from "./FaqsElements.vue?vue&type=template&id=3180f624&scoped=true&"
import script from "./FaqsElements.vue?vue&type=script&lang=js&"
export * from "./FaqsElements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3180f624",
  null
  
)

export default component.exports